import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';
import { MasterModelService } from 'src/app/share/services/master-model/master-model.service';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { MessageService } from 'src/app/share/sharedsubject';

@Component({
    selector: 'app-stock-transfer-to-branch',
    templateUrl: './stock-transfer-to-branch.component.html',
    styleUrls: ['./stock-transfer-to-branch.component.scss'],
    standalone: false
})
export class StockTransferToBranchComponent implements OnInit {

  customSearchFn = () => true;
  returnToBranchForm: FormGroup;
  companyData: any[];
  filteredActiveBranches: any[] = [];
  filteredToBranchList: any[] = [];
  isLoading = false;
  userDetails: any;
  resMsg: string;
  endOfResults: boolean = false;
  endOfResult: boolean = false
  tyreMakeObj: any = {}
  tyreModelObj: any = { page: 0 }
  tyreSizeObj: any = { page: 0 }
  branchData: any;
  transactionId: string = ''
  tyreSizeList: {search:string, list:any[], page:number}[] = [{ search: '', list: [], page: 0}];
  tyreMakeList: { search: string, list: any[] }[] = [{ search: '', list: [] }];
  tyreModelList: { search: string, list: any[], page: number }[] = [{ search: '', list: [], page: 0 }];
  priceDetailsArray: { minPrice: number; maxPrice: number; avgPrice: number }[] = [];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly stockService: StockService,
    private readonly masterModelService: MasterModelService,
    private readonly masterMakeService: MasterMakeService,
    private readonly companyService: CompanyServiceService,
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly messageService: MessageService,
    private readonly route: ActivatedRoute,
  ) {
    this.userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    this.returnToBranchForm = this.formBuilder.group({
      fromBranch: this.userDetails?.enrollmentType === 'Company' ? [null, Validators.required] : [null],
      toBranch: [null, [Validators.required]],
      stock: this.formBuilder.array([this.transferDetailsGroup()]),
      editReason: ['']
    });
    this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
  }

  transferDetailsGroup(): FormGroup {
    return this.formBuilder.group({
      tyreSize: [null, Validators.required],
      tyreMake: [null, Validators.required],
      tyreModel: [null],
      quantity: ['', [Validators.required, Validators.min(1)]],
    });
  }

  get stock(): FormArray {
    return this.returnToBranchForm.get('stock') as FormArray;
  }

  addItem(index: number): void {
    if(this.transactionId) return
    this.stock.push(this.transferDetailsGroup());
    this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
    this.tyreSizeList.push({ search: '', list: [], page: 0});
    this.tyreMakeList.push({ search: '', list: [] });
    this.tyreModelList.push({ search: '', list: [], page: 0 });
    let newIndex = index+1;
    this.initData(newIndex);
  }

  removeItem(index: number): void {
    if (this.transactionId) return
    this.stock.removeAt(index);
    this.priceDetailsArray.splice(index, 1);
    this.tyreSizeList.splice(index, 1);
    this.tyreMakeList.splice(index, 1);
    this.tyreModelList.splice(index, 1);
  }

  ngOnInit(): void {
    this.getBranchList();
    this.userDetails = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if (this.userDetails?.enrollmentType === 'Company') {
      this.getAllCompanyList();
    }
    this.returnToBranchForm.get('fromBranch')?.valueChanges.subscribe(() => {
      this.updateBranchLists();
    });
    this.returnToBranchForm.get('toBranch')?.valueChanges.subscribe(() => {
      this.updateBranchLists();
    });
    this.route.queryParams.subscribe((params: any) => {
      if (params['id']) {
        this.transactionId = params['id'];
        this.returnToBranchForm.get('editReason')?.setValidators([Validators.required]);
        this.returnToBranchForm.get('editReason')?.updateValueAndValidity();
        this.getTransactionDetails();
      } else {
        this.initData(0);
      }
    });
  }

  getTransactionDetails() {
    this.stockService.getTransactionDetails(this.transactionId).subscribe({
      next: (res: any) => {
        if (res.data) {
          this.patchResponse(res.data);
        }
      },
      error: (error: any) => {
        this.resMsg = error?.error?.error?.message || 'Something went wrong';
      }
    })
  }

  patchResponse(data: any) {
    if (!data) return;

    this.returnToBranchForm.patchValue({
      fromBranch: data.fromBranch,
      toBranch: data.toBranch
    });

    this.returnToBranchForm.get('fromBranch')?.disable();
    this.returnToBranchForm.get('toBranch')?.disable();

    const stockFormArray = this.returnToBranchForm.get('stock') as FormArray;
    stockFormArray.clear();
    this.priceDetailsArray = [];
    this.tyreSizeList = [];
    this.tyreMakeList = [];
    this.tyreModelList = [];

    if (data.stock && Array.isArray(data.stock)) {
      data.stock.forEach((item: any, index: number) => {
        const group = this.transferDetailsGroup();
        group.patchValue({
          tyreSize: item.tyreSize,
          tyreMake: item.tyreMake,
          tyreModel: item.tyreModel,
          quantity: item.quantity,
        });

        group.get('tyreSize')?.disable();
        group.get('tyreMake')?.disable();
        group.get('tyreModel')?.disable();

        stockFormArray.push(group);

        this.priceDetailsArray.push({ minPrice: 0, maxPrice: 0, avgPrice: 0 });
        this.tyreSizeList.push({ search: '', list: [{ tyreSize: item.tyreSize }], page: 0 });
        this.tyreMakeList.push({ search: '', list: [item.tyreMake] });
        this.tyreModelList.push({ search: '', list: [{ name: item.tyreModel }], page: 0 });
      });
    }
  }

  saveTransferData() {
    this.isLoading = true;
    const formValue = this.returnToBranchForm.getRawValue();
    if (this.transactionId) {
      this.stockService.saveBranchStockTransferEdit(this.transactionId, formValue).subscribe({
        next:(res: any) => {
          this.isLoading = false;
          setTimeout(() => {
            this.messageService.sendMessage(res.message);
          })
          this.router.navigate(['/order-list'])
        },
        error:(error: any) => {
          this.isLoading = false;
          this.resMsg = error?.error?.error?.message;
        }
      })
    } else {
      delete formValue.editReason
      this.stockService.saveTransferFromBranchDetails(formValue).subscribe({
        next: (res: any) => {
          this.isLoading = false;
          setTimeout(() => {
            this.messageService.sendMessage(res.message);
          })
          this.router.navigate(['/order-list'])
        },
        error: (error: any) => {
          this.isLoading = false;
          this.resMsg = error?.error?.error?.message;
        }
      })
    }
  }

  getAllCompanyList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      this.companyData = res.data;
      this.updateBranchLists();
    });
  }

  getBranchList() {
    this.stockService.getBranchList({ status: "Active" }).subscribe((res: any) => {
      this.branchData = res.data;
      this.updateBranchLists();
    });
  }

  updateBranchLists() {
    const fromBranchVal = this.returnToBranchForm?.get('fromBranch')?.value;
    const toBranchVal = this.returnToBranchForm?.get('toBranch')?.value;

    this.filteredActiveBranches = this.companyData?.filter(company => company.status === 'Active')
      .map(company => ({ ...company, disabled: toBranchVal === company._id })) || [];

    this.filteredToBranchList = this.branchData?.map((branch: any) => ({ ...branch, disabled: fromBranchVal === branch._id })) || [];
  }

  getTyreSize(index: number) {
    this.stockService.getTyreDetails(this.tyreSizeObj).subscribe((res: any) => {
      if (this.tyreSizeObj.page == 0) {
        this.tyreSizeList[index].list = res.data || []
      } else {
        this.tyreSizeList[index].list = this.tyreSizeList[index].list.concat(res.data || []);
      }
    })
  }

  getTyreModel(selectedMake: any, index: number = -1) {
    this.masterModelService.getTyreModelList(selectedMake, this.tyreModelObj).subscribe((res: any) => {
      if (this.tyreModelObj.page == 0) {
        this.tyreModelList[index].list = res.data || []
      } else {
        this.tyreModelList[index].list = this.tyreModelList[index].list.concat(res.data || []);
      }
    });
  }

  getTyreMake(index:number = -1) {
    this.masterMakeService.getTyreMakeBySize(this.tyreMakeObj.page, this.tyreMakeObj.searchTerm).subscribe((res: any) => {
      if (index == -1) {
        this.tyreMakeList.push({ search: '', list: res.data || [] })
      } else {
        this.tyreMakeList[index] = { search: this.tyreMakeObj.searchTerm, list: res.data || [] }
      }
    })
  }



  selectMake(value: any, index: any) {
    let selectedTyre: any = this.stock?.controls[index];
    selectedTyre?.controls['tyreModel'].setValue(null);
    this.endOfResult = false;
    this.tyreModelObj.page = 0
    this.tyreModelObj.name = '';
    this.tyreModelObj.tyreMake = value || ''
    this.tyreModelList[index].page = 0;
    this.tyreModelList[index].search = '';
    this.tyreModelList[index].list = [];
    if(!value) return
    this.getTyreModel(this.tyreModelObj, index)
    this.getFreightDetails(index);
  }

  onTyreMakeInputChange(event: any, index: number) {
    this.tyreMakeObj.page = 0
    this.tyreMakeList[index].list = [];
    let search = event?.term ? event.term : '';
    this.tyreMakeList[index].search = search
    this.tyreMakeObj.searchTerm = search
    this.getTyreMake(index)
  }

  onTyreModelInputChange(event: any, index: number) {
    this.tyreModelList[index].list = [];
    let tyreModel = event?.term ? event.term : '';
    this.tyreModelList[index].search = tyreModel;
    this.tyreModelObj.page= 0;
    this.tyreModelList[index].page = 0;
    this.tyreModelObj.name = tyreModel;
    let selectedTyre: any = this.stock?.controls[index];
    let makeValue = selectedTyre?.controls['tyreMake'].value
    this.tyreModelObj.tyreMake = makeValue;
    this.getTyreModel(this.tyreModelObj, index);
  }

  onTyreSizeInputChange(event: any, index: number) {
    this.tyreSizeObj.page = 0
    this.tyreSizeList[index].page = 0;
    let searchTerm = event?.term ? event.term : '';
    this.tyreSizeList[index].search = searchTerm
    this.tyreSizeObj.searchTerm = searchTerm
    this.getTyreSize(index)
  }


  onScroll() {
    if (this.endOfResults) {
      return;
    } else {
      this.tyreMakeObj.page++
      this.getTyreMake()
    }
  }

  onScrollTyreSize(index: number) {
    if (this.tyreSizeList[index].list.length % 20 === 0) {
      this.tyreSizeList[index].page++
      this.tyreSizeObj.page = this.tyreSizeList[index].page;
      this.tyreSizeObj.searchTerm = this.tyreSizeList[index].search;
      this.getTyreSize(index);
    }
  }

  scroll(index : number) {
    if (this.endOfResult) {
      return;
    }
    let selectedGroup: any = this.stock?.controls[index];
    let selectedTyreMake = selectedGroup?.controls['tyreMake'].value;
    this.tyreModelObj.tyreMake = selectedTyreMake;
    this.tyreModelObj.name = this.tyreModelList[index].search;
    this.tyreModelList[index].page++;
    this.tyreModelObj.page = this.tyreModelList[index].page;
    this.getTyreModel(this.tyreModelObj, index)
  }

  initData(index: number = -1) {
    this.tyreSizeObj.searchTerm = "";
    this.tyreSizeObj.page = 0;
    this.tyreMakeObj.searchTerm = "";
    this.tyreModelObj.name = "";
    this.getTyreSize(index);
    this.getTyreMake(index);
  }

  getFreightDetails(index: any) {
    const tyreSize = this.returnToBranchForm.value.stock[index].tyreSize;
    const tyreMake = this.returnToBranchForm.value.stock[index].tyreMake;
    const tyreModel = this.returnToBranchForm.value.stock[index].tyreModel;
    let payload : any ={
      tyreSize,
      tyreMake,
      tyreModel
      }
    if (!tyreSize || !tyreMake) {
      return;
    }
    this.isLoading = true;
    this.stockService.freightDetails(payload).subscribe({
      next: (res: any) => {
        setTimeout(() => {
          this.isLoading = false;
          this.priceDetailsArray[index] = {
            minPrice: res?.data?.minPrice || 0,
            maxPrice: res?.data?.maxPrice || 0,
            avgPrice: res?.data?.avgPrice || 0,
          };
        });
        this.resMsg = '';
      },
      error: (error) => {
        this.isLoading = false;
        this.resMsg = error?.error?.error?.message;
      }
    });
  }

  protected readonly faPlus = faPlus;
  protected readonly faTrash = faTrash;
}
